export default {
  name: "IosSwitcher",
  data() {
    return {
      form: {
        value: this.$props.value
      }
    };
  },
  props: {
    value: !Boolean
  },
  methods: {
    onInput(ev) {
      this.$emit("input", ev.target.value);
      this.$emit("change", ev.target.value);
    },
    setValue(value) {
      this.form.value = value;
      this.$emit("input", value);
      this.$emit("change", value);
    }
  }
};